module.exports = __webpack_public_path__ + "img/10.c2e00974.jpg";